eshopApp.controller('ShippingMethodSelectorController',  ['$scope', '$http', '$cookies', '$rootScope', function($scope, $http, $cookies, $rootScope) {

    // Helpers
    $scope.helper = CustomNameSpace.helpers;

    $rootScope.m_ShippingMethodSelector = false;

    $rootScope.shippingSuccess = false;
    //$scope.shipping_success = false;
    $scope.spinner = false;

    $scope.selected_index = null;
    $scope.selected_shippingmethod_option_id = null;

    $scope.shippingmethod_options = false;
    $scope.options_not_allowed = false;
    $scope.options_not_allowed_msg = {};

    $scope.offices_loader = false;

    $scope.mh_offices = false;
    $scope.selectedMhOffice = false;
    $scope.mh_offices_error = false;

    $scope.smartpost_offices = false;
    $scope.selectedSmartpostOffice = false;
    $scope.smartpost_offices_error = false;

    // Get shipping methods
    $scope.getShippingmethods = function() {
        $scope.spinner = true;
        $http.get('/m/shippingmethodselector', function() {}).success(function(response) {
            if (response.data) {
                $scope.shippingmethods = response.data;
            }
        }).error(function() {

        }).finally(function() {
            $scope.spinner = false;
        });
    };
    // Init
    $scope.getShippingmethods();

    // Set shipping method
    $scope.setShipping = function(shipping_id, index, shipping_handle) {
        $scope.options_not_allowed = false;
        $scope.options_not_allowed_msg = {};
        $scope.mh_offices = false;
        $scope.mh_offices_error = false;
        $scope.smartpost_offices = false;
        $scope.smartpost_offices_error = false;

        $scope.selected_shippingmethod_option_id = null;
        if ($scope.spinner === true) {
            return false;
        }
        $scope.spinner = true;
        $http.get('/a/set_shippingmethod/' + shipping_id).success(function(response) {
            if (response.data === 'success') {
                $scope.selected_index = index;
                $rootScope.shippingSuccess = true;

                // Show shipping methods
                //$scope.getShippingmethodOptions(shipping_id, shipping_handle);
            }
        }).error(function() {
            $rootScope.shippingSuccess = false;
        }).finally(function() {
            $scope.spinner = false;
        });
    };

    // Get shipping method options
    /*$scope.getShippingmethodOptions = function(shipping_id, shipping_handle) {
        $http.get('/m/shippingmethodselector/options/' + shipping_id, function() {}).success(function(response) {
            if (response.data !== false && response.data.length !== 0) {

                // Options found
                $scope.shippingmethod_options = response.data;
                $scope.shipping_success = false;

            } else if (response.data === false) {

                // Boolean false response, NO OPTIONS ALLOWED
                $scope.shippingmethod_options = false;
                $scope.options_not_allowed = true;

                if (shipping_handle == 'own_shipping') {

                    // Own shipping (Heinäpojat-rahti)
                    $scope.options_not_allowed_msg.own_shipping = true;

                } else if (shipping_handle == 'matkahuolto') {

                    // Matkahuolto
                    $scope.options_not_allowed_msg.matkahuolto = true;
                }
                else if (shipping_handle == 'smartpost') {

                    // Smartpost
                    $scope.options_not_allowed_msg.smartpost = true;

                } else if (shipping_handle == 'bb') {

                    // BB
                   $scope.options_not_allowed_msg.bb = true;
                }

                $scope.shipping_success = false;

            } else {

                // Empty response, NO OPTIONS EXIST
                $scope.shippingmethod_options = false;
                $scope.shipping_success = true;

            }

        }).finally(function() {
            $scope.spinner = false;
        });
    };

    // Set shippingmethod option
    $scope.setShippingmethodOption = function(shippingmethodoption_id, shippingmethodoption_handle) {
        if ($scope.spinner === true) {
            return false;
        }
        $scope.spinner = true;

        $scope.mh_offices = false;
        $scope.smartpost_offices = false;

        $http.get('/a/set_shippingmethodoption/' + shippingmethodoption_id).success(function(response) {
            if (response.data === 'success') {
                $scope.selected_shippingmethod_option_id = shippingmethodoption_id;
                switch (shippingmethodoption_handle) {
                    // Matkahuolto
                    case 'matkahuoltolahi':
                        $scope.getMhOffices();
                        break;
                    case 'matkahuoltobussi':
                    case 'matkahuoltopika':
                    case 'matkahuoltojako':
                        $scope.shipping_success = true;
                        break;
                    // Smartpost
                    case 'smartpost_s':
                    case 'smartpost_m':
                    case 'smartpost_l':
                    case 'smartpost_xl':
                        $scope.getSmartpostOffices();
                        break;

                    default:
                        $scope.shipping_success = true;
                }
            }
        }).finally(function() {
            $scope.spinner = false;
        });
    };

    // Hide the module and show payment method selector
    $scope.showPaymentMethodSelector = function() {
        $rootScope.m_ShippingMethodSelector = false;
        $rootScope.m_PaymentMethodSelector = true;
    };

    $scope.showQuickRegister = function() {
        $rootScope.$emit('showQuickRegister', 'guest');
        $rootScope.m_ShippingMethodSelector = false;
        $rootScope.m_FullCart = false;
    };

    // | ------------------------
    // | SmartPOST
    // | ------------------------

    $scope.getSmartpostOffices = function() {
        $scope.shipping_success = false;
        if ($scope.offices_loader === true) {
            return false;
        }
        if (!$scope.smartpost_offices) {
            $scope.offices_loader = true;
        }
        $http.get('/shipping/smartpost').success(function(response) {
            if (response && response.data) {
                if (!$scope.smartpost_offices) {
                    $scope.smartpost_offices = response.data;
                }
            } else {
                $scope.smartpost_offices = false;
                $scope.smartpost_offices_error = true;
            }
        }).finally(function() {
            $scope.offices_loader = false;
        });
    };

    // Set SmartPOST office
    $scope.setSmartpostOffice = function(data) {
        $scope.shipping_success = false;
        if (data == null) {
            $scope.selectedSmartPostOffice = false;
            return false;
        }
        if ($scope.offices_loader === true) {
            return false;
        }
        // Save MH office for cart
        $http.post('/shipping/smartpost', data).success(function(response) {
            $scope.shipping_success = true;
        }).finally(function() {
            $scope.offices_loader = false;
        });
    };

    // | ------------------------
    // | Matkahuolto
    // | ------------------------

    // Get Matkahuolto offices
    $scope.getMhOffices = function() {
        $scope.shipping_success = false;
        if ($scope.offices_loader === true) {
            return false;
        }
        if (!$scope.mh_offices) {
            $scope.offices_loader = true;
        }
        $http.get('/shipping/matkahuolto').success(function(response) {
            if (response.data && response.data.length) {
                if (!$scope.mh_offices) {
                    $scope.mh_offices = response.data;
                    $scope.selectedMhOffice = false;
                }
                $scope.mh_offices_error = false;
            } else {
                $scope.mh_offices = false;
                $scope.mh_offices_error = true;
            }
        }).finally(function() {
            $scope.offices_loader = false;
        });
    };

    // Set Matkahuolto office
    $scope.setMhOffice = function(data) {
        $scope.shipping_success = false;
        if (data == null) {
            $scope.selectedMhOffice = false;
            return false;
        }
        if ($scope.offices_loader === true) {
            return false;
        }
        // Save MH office for cart
        $http.post('/shipping/matkahuolto', data).success(function(response) {
            $scope.shipping_success = true;
        }).finally(function() {
            $scope.offices_loader = false;
        });
    };*/

}]);
